<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">Table of Contents</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Dedication#uuhALapISGPeKY9fokEsx2A" title="Link target outside of Sample">Dedication</span></div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chapter_01#ucWDNyqLxA58lzivc4qzTxA">CHAPTER ONE</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chapter_02#ukKrGwYnNlMVUPJYardTWhB">CHAPTER TWO</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chapter_03#uix8KfRWCtBSZozHJqX2cqE">CHAPTER THREE</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chapter_04#ugqmX9BtRFAel5dnXIHnguB">CHAPTER FOUR</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_05#uizYw26MNcYeqq2A6bDjUD7" title="Link target outside of Sample">CHAPTER FIVE</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_06#uHM5DE8jFeQzY3gTBR3Foi7" title="Link target outside of Sample">CHAPTER SIX</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_07#u6tyjTK5QID6BwTK434IOo3" title="Link target outside of Sample">CHAPTER SEVEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_08#uwbkT9F9kM3ylDXTrHcn9HE" title="Link target outside of Sample">CHAPTER EIGHT</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_09#uyxZN64lVLs4bHlkeB9Wbi5" title="Link target outside of Sample">CHAPTER NINE</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_10#uWRUylgFJBV4GfsY3S622F9" title="Link target outside of Sample">CHAPTER TEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_11#uEXi8zt3UBZRJ64Wf8DG89G" title="Link target outside of Sample">CHAPTER ELEVEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_12#uc4ZVMQiK8NCdVIzq4DDAQB" title="Link target outside of Sample">CHAPTER TWELVE</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_13#uIyQH8FEWfILpRmMyOuNjs7" title="Link target outside of Sample">CHAPTER THIRTEEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_14#uh4tvPgi8cehMz9jCTFTMoF" title="Link target outside of Sample">CHAPTER FOURTEEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_15#uiNuem8rKJCydCVsvzWNcpF" title="Link target outside of Sample">CHAPTER FIFTEEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_16#uQrhAWl3KYETCvk5bgJ8Ki3" title="Link target outside of Sample">CHAPTER SIXTEEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_17#ucpbflJfBTMJhXe8LrVkIKB" title="Link target outside of Sample">CHAPTER SEVENTEEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_18#u2QNBJZK2zfLVAYRqdi5dy7" title="Link target outside of Sample">CHAPTER EIGHTEEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_19#ufl2yz2JS4DaqLoYp57wn4F" title="Link target outside of Sample">CHAPTER NINETEEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_20#u95ikYObq2HjddiCTkW3al9" title="Link target outside of Sample">CHAPTER TWENTY</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Afterword#up9a87HcZiugXggbHzWcYXB" title="Link target outside of Sample">AFTERWORD</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?77431530